module.exports = __webpack_public_path__ + "img/thumbs-up.c8472b8a.svg";